import { getUsersState } from '../selectors';

export const getUsersListState = state => getUsersState(state).list;
export const getUsers = state => getUsersListState(state).data;
